export default {
  cartItemContainerBorder: `1px solid ${Styles.color.grey.four}`,
  cartItemDescriptionColor: Styles.color.black,
  headerColor: Styles.color.black,
};
